import { useState, useEffect } from "react";

const useWindow = () => {
    const [windowSize, setWindowSize] = useState({
        width: 1440,
        height: 900,
    });
    
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}

export default useWindow;